import React, { useEffect } from 'react';
import { useAppDispatch } from 'src/store/hooks';
import { fetchAdmins } from 'src/actions/watcher/adminsActions';
import { setNewParams } from 'src/store/watcher/adminsSlice';

import PageLayout from '../_partials/PageLayout';
import New from './New';
import Edit from './Edit';
import ListTable from './_partials/_ListTable';
import PageHeader from 'src/componets/PageHeader';
import Wrapper from 'src/componets/Wrapper';
import NavBarThree from 'src/componets/NavBarThree';
import { PlusOutlined } from '@ant-design/icons';

const Admins = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchAdmins());
  }, [dispatch]);

  function onClickCreate() {
    dispatch(setNewParams({ role: 'developer' }));
  }

  return (
    <PageLayout className='v-admins'>
      <PageHeader title='Admins' />

      <Wrapper>
        <NavBarThree>
          <NavBarThree.Button className='v-link2' onClick={onClickCreate}>
            <PlusOutlined /> Create Admin
          </NavBarThree.Button>
        </NavBarThree>
      </Wrapper>

      <div className='v-container'>
        <ListTable />
      </div>

      <New />
      <Edit />
    </PageLayout>
  );
}

export default Admins;
